export default {
  namespaced: true,

  state: {
    // State is kept for potential future use if components need shared state
    // Currently components manage their own state and use the model for API calls
  },

  mutations: {
    // Mutations are kept for potential future use if components need shared state
  },

  actions: {
    // All API actions have been removed
    // Components now use the ai-employee model directly for API calls
  }
};